import { strategies } from "../investment-strategy/strategyData";
import { StrategyType } from "../investment-strategy/InvestmentStrategyContext";

interface CustomAllocations {
  Stocks: number;
  Bonds: number;
  Cash: number;
  Alternatives: number;
}

interface StrategyDisplayProps {
  selectedStrategy?: StrategyType;
  customAllocations?: CustomAllocations | null;
  onTotalChange?: (total: number) => void;
}

const StrategyDisplay = ({ selectedStrategy, customAllocations, onTotalChange }: StrategyDisplayProps) => {
  if (!selectedStrategy) return null;

  const calculateTotal = (allocations: Record<string, number>) => {
    return Object.values(allocations).reduce((sum, value) => sum + Number(value), 0);
  };

  const formatStrategyDisplay = () => {
    if (selectedStrategy === 'custom' && customAllocations) {
      // Convert CustomAllocations to Record<string, number> before calculating total
      const allocationsRecord: Record<string, number> = {
        stocks: customAllocations.Stocks,
        bonds: customAllocations.Bonds,
        cash: customAllocations.Cash,
        alts: customAllocations.Alternatives
      };
      const total = calculateTotal(allocationsRecord);
      if (onTotalChange) onTotalChange(total);
      return `stocks ${customAllocations.Stocks}%, bonds ${customAllocations.Bonds}%, cash ${customAllocations.Cash}%, alts ${customAllocations.Alternatives}%`;
    }

    const strategy = strategies.find(s => s.id === selectedStrategy);
    if (strategy) {
      const total = calculateTotal(strategy.allocation);
      if (onTotalChange) onTotalChange(total);
      return `stocks ${strategy.allocation.stocks}%, bonds ${strategy.allocation.bonds}%, cash ${strategy.allocation.cash}%, alts ${strategy.allocation.alts}%`;
    }

    return selectedStrategy;
  };

  return (
    <div className="bg-navy/10 p-4 rounded-lg border border-navy/20">
      <p className="text-navy-dark font-semibold">Selected Strategy: {formatStrategyDisplay()}</p>
      <p className="text-navy-light mt-1 text-sm">Raw strategy value: {selectedStrategy}</p>
    </div>
  );
};

export default StrategyDisplay;